import React from "react";
import PropTypes from "prop-types";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import * as S from "./FileValidationCard.styles";

const formatFileSize = (bytes) => {
  if (bytes == null) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const formatFileDate = (timestamp) => {
  if (timestamp == null) return "-";
  return new Date(timestamp).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const FileValidationCard = ({
  variant = "success",
  file,
  message,
  action,
  icon,
}) => {
  const statusIcon =
    icon ||
    (variant === "error" ? (
      <ErrorOutlineIcon style={{ fontSize: 24 }} />
    ) : (
      <CheckCircleIcon style={{ fontSize: 24 }} />
    ));

  return (
    <S.Card>
      <S.FileInfoRow>
        <S.FileInfoName>{file?.name || "Arquivo"}</S.FileInfoName>
        <S.FileInfoMeta>
          <span>Tamanho: {formatFileSize(file?.size)}</span>
          <span>Modificado: {formatFileDate(file?.lastModified)}</span>
        </S.FileInfoMeta>
      </S.FileInfoRow>

      {variant === "error" && message && (
        <>
          <S.Separator />
          <S.StatusSection variant={variant}>
            <div className="file-status-icon">{statusIcon}</div>
            <div className="file-status-message">{message}</div>
            {action ? <div className="file-status-action">{action}</div> : null}
          </S.StatusSection>
        </>
      )}
    </S.Card>
  );
};

FileValidationCard.propTypes = {
  variant: PropTypes.oneOf(["success", "error"]),
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    lastModified: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  message: PropTypes.node,
  action: PropTypes.node,
  icon: PropTypes.node,
};

export default FileValidationCard;